import React from 'react';
import { ShieldIcon, ClipboardCheckIcon, HeartIcon } from 'lucide-react';
interface HomePageProps {
  onPanicPress: () => void;
  onCheckInPress: () => void;
  urgeBeatenCount: number;
  hasPartner: boolean;
  partnerName?: string;
  partnerStatus?: string;
}
function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 6) return 'Peace be upon you in this quiet hour';
  if (hour < 12) return 'Good morning, brother';
  if (hour < 17) return 'Good afternoon, brother';
  if (hour < 21) return 'Good evening, brother';
  return 'Peace be upon you tonight, brother';
}
export function HomePage({
  onPanicPress,
  onCheckInPress,
  urgeBeatenCount,
  hasPartner,
  partnerName,
  partnerStatus
}: HomePageProps) {
  const greeting = getGreeting();
  return <main className="flex flex-col items-center px-5 pt-12 pb-32 min-h-screen" data-id="element-72">
      {/* Greeting */}
      <div className="w-full text-center mb-10" data-id="element-73">
        <p className="text-sm text-muted-foreground mb-1 font-medium tracking-wide" data-id="element-74">
          بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ
        </p>
        <h1 className="text-2xl font-bold text-foreground mb-1" data-id="element-75">
          Assalamu Alaikum
        </h1>
        <p className="text-muted-foreground text-base" data-id="element-76">{greeting}</p>
      </div>

      {/* Panic Button */}
      <button onClick={onPanicPress} className="w-full bg-primary text-primary-foreground font-semibold text-lg rounded-lg py-4 px-6 min-h-[56px] shadow-md hover:shadow-lg active:scale-[0.98] transition-all duration-150 flex items-center justify-center gap-3 mb-6" aria-label="I need help now — start urge intervention" data-id="element-77">
        <ShieldIcon className="w-6 h-6" data-id="element-78" />I need help now
      </button>

      {/* Urge beaten count */}
      {urgeBeatenCount > 0 && <div className="w-full bg-card rounded-lg p-4 mb-4 flex items-center gap-3 border border-border" data-id="element-79">
          <div className="w-10 h-10 rounded-full bg-success/20 flex items-center justify-center flex-shrink-0" data-id="element-80">
            <HeartIcon className="w-5 h-5 text-success" data-id="element-81" />
          </div>
          <div data-id="element-82">
            <p className="text-sm text-muted-foreground" data-id="element-83">Urges beaten</p>
            <p className="text-lg font-semibold text-foreground" data-id="element-84">
              {urgeBeatenCount}
            </p>
          </div>
        </div>}

      {/* Check-in card */}
      <button onClick={onCheckInPress} className="w-full bg-card rounded-lg p-5 border border-border text-left hover:border-primary/40 active:scale-[0.99] transition-all duration-150 mb-4 min-h-[48px]" aria-label="Go to daily check-in" data-id="element-85">
        <div className="flex items-center gap-3" data-id="element-86">
          <div className="w-10 h-10 rounded-full bg-highlight/40 flex items-center justify-center flex-shrink-0" data-id="element-87">
            <ClipboardCheckIcon className="w-5 h-5 text-primary" data-id="element-88" />
          </div>
          <div data-id="element-89">
            <p className="font-semibold text-foreground" data-id="element-90">Daily check-in</p>
            <p className="text-sm text-muted-foreground" data-id="element-91">
              How's your day going, brother?
            </p>
          </div>
        </div>
      </button>

      {/* Partner status card */}
      {hasPartner && partnerName && <div className="w-full bg-card rounded-lg p-4 border border-border" data-id="element-92">
          <div className="flex items-center gap-3" data-id="element-93">
            <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0" data-id="element-94">
              <span className="text-sm font-bold text-primary" data-id="element-95">AP</span>
            </div>
            <div className="flex-1 min-w-0" data-id="element-96">
              <p className="font-medium text-foreground text-sm" data-id="element-97">
                {partnerName}
              </p>
              <p className="text-xs text-muted-foreground" data-id="element-98">{partnerStatus}</p>
            </div>
            <div className="w-2.5 h-2.5 rounded-full bg-green-400 flex-shrink-0" data-id="element-99" />
          </div>
        </div>}

      {/* Quiet encouragement */}
      <div className="mt-auto pt-10 text-center" data-id="element-100">
        <p className="text-sm text-muted-foreground italic" data-id="element-101">
          "Verily, with hardship comes ease."
        </p>
        <p className="text-xs text-muted-foreground mt-1" data-id="element-102">
          — Surah Ash-Sharh (94:6)
        </p>
      </div>
    </main>;
}